import { Component, Element, Host, h, Prop, Fragment } from '@stencil/core';
import { trimChildNodes } from '../../utils/utils';

@Component({
  tag: 'me-headline',
  styleUrl: 'me-headline.scss',
  shadow: false,
})
export class MeHeadline {

  @Element() host: HTMLElement;

  @Prop() tag: string = 'h2';
  @Prop() variant: string = 'page';
  @Prop({ reflect: true }) href?: string;
  @Prop() target = '_self';
  @Prop() center: boolean = false;
  @Prop() inverse: boolean = false;
  @Prop() inline: boolean = false;
  @Prop() lineClamp?: string = null;

  private hasIconLeftElement = false;
  private hasIconRightElement = false;

  componentWillLoad() {
    this.hasIconLeftElement = Boolean(this.host.querySelector(':scope > [slot=icon-left]'));
    this.hasIconRightElement = Boolean(this.host.querySelector(':scope > [slot=icon-right]'));

    trimChildNodes(this.host);
  }

  render() {
    const classList = [
      'me-headline',
      `me-headline--${this.variant}`,
      this.center ? 'me-headline--center' : null,
      this.href ? 'me-headline--href' : null,
      this.inverse ? 'me-headline--inverse' : null,
      this.inline ? 'me-headline--inline' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host
        class={classList}
        style={{'--me-line-clamp-max-lines': this.lineClamp ?? null}}
      >
        {this.href
          ? (
            <a
              href={this.href}
              target={this.target}
              class="me-headline__link"
            >
              {this.content()}
            </a>
          )
          : this.content()
        }
      </Host>
    );
  }

  protected content() {
    return (
      <this.tag class="me-headline__tag">
        {this.hasIconLeftElement
          ? <Fragment><slot name="icon-left" />&nbsp;</Fragment>
          : ''
        }
        <slot />
        {this.hasIconRightElement
          ? <Fragment>&nbsp;<slot name="icon-right" /></Fragment>
          : ''
        }
        {!this.hasIconRightElement && this.variant === 'collection' && this.href
          ? <Fragment>&nbsp;<i class="fa-solid fa-chevron-right fa-xs" /></Fragment>
          : ''
        }
      </this.tag>
    );
  }
}
